import * as React from "react";
import * as uuid from "uuid";

import { ProductListStateProvider } from "./product-list-state-provider";
import { ProductListUrlStateProvider } from "./product-list-url-state-provider";
import { ProductListRunningCacheProvider } from "./product-list-running-cache-provider";
import { ProductListAutoInitializationProvider } from "./product-list-auto-initialization-provider";
import { ProductListPresentationModelProvider } from "./product-list-presentation-model-provider";
import { ProductListLoadingStateProvider } from "./product-list-loading-state-provider";
import { ProductListPaginationProvider } from "./product-list-pagination-provider";
import { ProductListRestoreScrollProvider } from "./product-list-restore-scroll-provider";
import { ProductListController_ForProduct_Provider } from "./product-list-controller-for-product-provider";
import { ProductListUrlStateControllerProvider } from "./product-list-url-state-controller-provider";
import { ProductListController_ForSorting_Provider } from "./product-list-controller-for-sorting";
import { ProductListController_ForFiltering_Provider } from "./product-list-controller-for-filtering";
import { ProductListDataProvider } from "./product-list-data-provider";
import { ProductListViewFreshResultsObserver } from "./product-list-view-fresh-results-observer";
import { ProductListFredhopperRedirectsProvider } from "./product-list-fredhopper-redirects-provider";

export const ProductListProvider: React.FunctionComponent = (props) => {
  const thisProviderId = uuid.v4();
  (window as any).plpProviderId = thisProviderId;

  return (
    <ProductListViewFreshResultsObserver providerId={thisProviderId}>
      <ProductListDataProvider>
        <ProductListStateProvider>
          <ProductListUrlStateProvider providerId={thisProviderId}>
            <ProductListRunningCacheProvider>
              <ProductListUrlStateControllerProvider>
                <ProductListPaginationProvider>
                  <ProductListRestoreScrollProvider>
                    <ProductListAutoInitializationProvider
                      providerId={thisProviderId}
                    >
                      <ProductListFredhopperRedirectsProvider
                        providerId={thisProviderId}
                      >
                        <ProductListLoadingStateProvider>
                          <ProductListPresentationModelProvider>
                            <ProductListController_ForSorting_Provider>
                              <ProductListController_ForFiltering_Provider>
                                <ProductListController_ForProduct_Provider>
                                  {props?.children || []}
                                </ProductListController_ForProduct_Provider>
                              </ProductListController_ForFiltering_Provider>
                            </ProductListController_ForSorting_Provider>
                          </ProductListPresentationModelProvider>
                        </ProductListLoadingStateProvider>
                      </ProductListFredhopperRedirectsProvider>
                    </ProductListAutoInitializationProvider>
                  </ProductListRestoreScrollProvider>
                </ProductListPaginationProvider>
              </ProductListUrlStateControllerProvider>
            </ProductListRunningCacheProvider>
          </ProductListUrlStateProvider>
        </ProductListStateProvider>
      </ProductListDataProvider>
    </ProductListViewFreshResultsObserver>
  );
};
